import createAction from 'redux-actions/lib/createAction';
import flat from 'flat';
/* --- JOIN --- */
export const JOIN_GROUP_REQUEST = 'JOIN_GROUP_REQUEST';
export const JOIN_GROUP_SUCCESS = 'JOIN_GROUP_SUCCESS';
export const JOIN_GROUP_FAILURE = 'JOIN_GROUP_FAILURE';

export const joinGroupRequest = createAction(JOIN_GROUP_REQUEST);
export const joinGroupSuccess = createAction(JOIN_GROUP_SUCCESS);
export const joinGroupFailure = createAction(JOIN_GROUP_FAILURE);

export const joinGroup = groupId => (dispatch, getState, {getGroupsApi}) => {
  dispatch(joinGroupRequest());
  const promise = getGroupsApi().post(`${groupId}/members/me`, {groupId});

  return promise
    .then(() => dispatch(joinGroupSuccess(groupId)), error => dispatch(joinGroupFailure(error)))
    .then(() => promise);
};

/* --- LEAVE --- */
export const LEAVE_GROUP_REQUEST = 'LEAVE_GROUP_REQUEST';
export const LEAVE_GROUP_SUCCESS = 'LEAVE_GROUP_SUCCESS';
export const LEAVE_GROUP_FAILURE = 'LEAVE_GROUP_FAILURE';

export const leaveGroupRequest = createAction(LEAVE_GROUP_REQUEST);
export const leaveGroupSuccess = createAction(LEAVE_GROUP_SUCCESS);
export const leaveGroupFailure = createAction(LEAVE_GROUP_FAILURE);

export const leaveGroup = groupId => (dispatch, getState, {getGroupsApi}) => {
  dispatch(leaveGroupRequest());
  const promise = getGroupsApi().delete(`${groupId}/members/me`, {groupId});

  return promise
    .then(() => dispatch(leaveGroupSuccess(groupId)), error => dispatch(leaveGroupFailure(error)))
    .then(() => promise);
};

/* --- REQUEST JOIN --- */
export const REQUEST_JOIN_GROUP_SUCCESS = 'REQUEST_JOIN_GROUP_SUCCESS';
export const REQUEST_JOIN_GROUP_REQUEST = 'REQUEST_JOIN_GROUP_REQUEST';
export const REQUEST_JOIN_GROUP_FAILURE = 'REQUEST_JOIN_GROUP_FAILURE';

export const requestJoinGroupRequest = createAction(REQUEST_JOIN_GROUP_REQUEST);
export const requestJoinGroupSuccess = createAction(REQUEST_JOIN_GROUP_SUCCESS);
export const requestJoinGroupFailure = createAction(REQUEST_JOIN_GROUP_FAILURE);

export const requestJoinGroup = groupId => (dispatch, getState, {getGroupsApi}) => {
  dispatch(requestJoinGroupRequest());
  const promise = getGroupsApi().post(`/${groupId}/members/request`);

  return promise
    .then(
      () => dispatch(requestJoinGroupSuccess(groupId)),
      error => dispatch(requestJoinGroupFailure(error)),
    )
    .then(() => promise);
};


/* --- WITHDRAW REQUEST JOIN --- */
export const WITHDRAW_REQUEST_JOIN_GROUP_SUCCESS = 'WITHDRAW_REQUEST_JOIN_GROUP_SUCCESS';
export const WITHDRAW_REQUEST_JOIN_GROUP_REQUEST = 'WITHDRAW_REQUEST_JOIN_GROUP_REQUEST';
export const WITHDRAW_REQUEST_JOIN_GROUP_FAILURE = 'WITHDRAW_REQUEST_JOIN_GROUP_FAILURE';

export const withdrawRequestJoinGroupRequest = createAction(WITHDRAW_REQUEST_JOIN_GROUP_REQUEST);
export const withdrawRequestJoinGroupSuccess = createAction(WITHDRAW_REQUEST_JOIN_GROUP_SUCCESS);
export const withdrawRequestJoinGroupFailure = createAction(WITHDRAW_REQUEST_JOIN_GROUP_FAILURE);

export const withdrawRequestJoinGroup = groupId => (dispatch, getState, {getGroupsApi}) => {
  dispatch(withdrawRequestJoinGroupRequest());
  const promise = getGroupsApi().delete(`/${groupId}/members/request`);

  return promise
    .then(
      () => dispatch(withdrawRequestJoinGroupSuccess(groupId)),
      error => dispatch(withdrawRequestJoinGroupFailure(error)),
    )
    .then(() => promise);
};


/* --- UPDATE GROUP --- */
export const UPDATE_GROUP_REQUEST = 'UPDATE_GROUP_REQUEST';
export const UPDATE_GROUP_SUCCESS = 'UPDATE_GROUP_SUCCESS';
export const UPDATE_GROUP_FAILURE = 'UPDATE_GROUP_FAILURE';

export const updateGroupRequest = createAction(UPDATE_GROUP_REQUEST);
export const updateGroupSuccess = createAction(UPDATE_GROUP_SUCCESS);
export const updateGroupFailure = createAction(UPDATE_GROUP_FAILURE);

export const updateGroup = (groupId, updatedGroup, optimistic = false) => (
  dispatch,
  getState,
  {getGroupsApi},
) => {
  const addFieldMask = o => {
    const paths = Object.keys(flat(o));
    return {...o, fieldMask: {paths}};
  };

  dispatch(updateGroupRequest());
  if (optimistic) {
    dispatch(updateGroupSuccess(updatedGroup));
  }

  const promise = getGroupsApi().patch(`/${groupId}`, addFieldMask(updatedGroup));

  return promise
    .then(
      () => !optimistic && dispatch(updateGroupSuccess(updatedGroup)),
      error => dispatch(updateGroupFailure(error)),
    )
    .then(() => promise);
};

export const updateCoverImage = (groupId, imageUrl) =>
  updateGroup(groupId, {details: {imageUrl}}, true);

/* --- ADD MEMBERS TO GROUP --- */
export const ADD_MEMBERS_TO_GROUP_REQUEST = 'ADD_MEMBERS_TO_GROUP_REQUEST';
export const ADD_MEMBERS_TO_GROUP_SUCCESS = 'ADD_MEMBERS_TO_GROUP_SUCCESS';
export const ADD_MEMBERS_TO_GROUP_FAILURE = 'ADD_MEMBERS_TO_GROUP_FAILURE';

export const addMembersToGroupRequest = createAction(ADD_MEMBERS_TO_GROUP_REQUEST);
export const addMembersToGroupSuccess = createAction(ADD_MEMBERS_TO_GROUP_SUCCESS);
export const addMembersToGroupFailure = createAction(ADD_MEMBERS_TO_GROUP_FAILURE);

export const addMembersToGroup = (groupId, siteMemberIds) => (
  dispatch,
  getState,
  {getGroupsApi},
) => {
  dispatch(addMembersToGroupRequest());
  const promise = getGroupsApi().post(`/${groupId}/members/add`, {groupId, siteMemberIds});

  return promise
    .then(
      () => dispatch(addMembersToGroupSuccess(({groupId, siteMemberIds}))),
      error => dispatch(addMembersToGroupFailure(error)),
    )
    .then(() => promise);
};

/* --- CONFIGURE APPS --- */
export const CONFIGURE_APPS_REQUEST = 'CONFIGURE_APPS_REQUEST';
export const CONFIGURE_APPS_SUCCESS = 'CONFIGURE_APPS_SUCCESS';
export const CONFIGURE_APPS_FAILURE = 'CONFIGURE_APPS_FAILURE';

export const listAppsRequest = createAction(CONFIGURE_APPS_REQUEST);
export const listAppsSuccess = createAction(CONFIGURE_APPS_SUCCESS);
export const listAppsFailure = createAction(CONFIGURE_APPS_FAILURE);

export const configureGroupApps = (groupId, apps) => (dispatch, getState, {getGroupsApi}) => {
  dispatch(listAppsRequest());
  const promise = getGroupsApi().post(`${groupId}/apps`, {apps});

  return promise
    .then(() => dispatch(listAppsSuccess(groupId)), error => dispatch(listAppsFailure(error)))
    .then(() => promise);
};

/* --- ARCHIVE APPS --- */
export const ARCHIVE_GROUP_REQUEST = 'ARCHIVE_GROUP_REQUEST';
export const ARCHIVE_GROUP_SUCCESS = 'ARCHIVE_GROUP_SUCCESS';
export const ARCHIVE_GROUP_FAILURE = 'ARCHIVE_GROUP_FAILURE';

export const archiveGroupRequest = createAction(ARCHIVE_GROUP_REQUEST);
export const archiveGroupSuccess = createAction(ARCHIVE_GROUP_SUCCESS);
export const archiveGroupFailure = createAction(
  ARCHIVE_GROUP_FAILURE,
  () => undefined,
  meta => meta,
);

export const archiveGroup = groupId => (dispatch, getState, {getGroupsApi}) => {
  dispatch(archiveGroupRequest());
  const promise = getGroupsApi().post(`/${groupId}/archive`);

  return promise
    .then(
      () => dispatch(archiveGroupSuccess(groupId)),
      error => dispatch(archiveGroupFailure(error)),
    )
    .then(() => promise);
};
